export default __webpack_public_path__ + "static/media/gallery_05.76a8aa01.jpg";